<template>
  <v-container class="d-flex flex-column ga-3">
    <UsageExample v-model="tab" :code="code" :tabs="tabs">
      <v-layout>
        <v-main height="450">
          <div class="d-flex flex-column align-center">
            <v-card elevation="4" class="ma-2" height="auto">
              <v-card-title class="font-weight-bold">Single Select</v-card-title>
              <v-card-text>
                <CsDropdownItemAdder
                  :label="label ? 'Filter by module' : undefined"
                  :optional-text="optionalText ? '(Optional)' : undefined"
                  :mandatory="mandatory ? true : undefined"
                  :placeholder="placeholder ? 'Select an option' : undefined"
                  :items="items"
                  :model-value="selectedItems"
                  :helper-message="helperMessage ? 'Helper message' : undefined"
                  :error-messages="errorMessages ? 'Error message' : undefined"
                  :disabled="disabled ? true : undefined"
                  :width="width ? '300' : undefined"
                  :removable="removable ? true : undefined"
                  @add-item="handleAddItem"
                  @remove-item="handleRemoveItem"
                />
              </v-card-text>
            </v-card>
          </div>
        </v-main>
      </v-layout>
      <template #configuration>
        <div class="d-flex flex-column">
          <v-checkbox v-model="label" label="Label" />
          <v-checkbox v-model="optionalText" label="Optional Text" />
          <v-checkbox v-model="mandatory" label="Mandatory" />
          <v-checkbox v-model="placeholder" label="Placeholder" />
          <v-checkbox v-model="helperMessage" label="Helper Message" />
          <v-checkbox v-model="errorMessages" label="Error Messages" />
          <v-checkbox v-model="disabled" label="Disabled" />
          <v-checkbox v-model="width" label="Width" />
          <v-checkbox v-model="removable" label="Removable" />
        </div>
      </template>
    </UsageExample>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'CustomCSDropdownItemAdder',
  components: { UsageExample },
  setup() {
    const code = `
<CSDropdownItemAdder
        :label="label ? 'Filter by module' : undefined"
        :optional-text="optionalText ? '(Optional)' : undefined"
        :mandatory="mandatory ? true : undefined"
        :placeholder="placeholder ? 'Select an option' : undefined"
        :items="items"
        :model-value="selectedItems"
        :helper-message="helperMessage ? 'Helper message' : undefined"
        :error-messages="errorMessages ? 'Error message' : undefined"
        :disabled="disabled ? true : undefined"
        :width="width ? '300' : undefined"
        :removable="removable ? true : undefined"
        @add-item="handleAddItem"
        @remove-item="handleRemoveItem"
      />
    `;
    return {
      code
    };
  },
  data() {
    return {
      tab: 'Select Usage',
      tabs: ['Select Usage'],
      items: [
        { title: 'United States', value: 'us', removable: true },
        { title: 'Canada', value: 'ca', removable: true },
        { title: 'Mexico', value: 'mx', removable: true },
        { title: 'United Kingdom', value: 'uk', removable: true },
        { title: 'Germany', value: 'de', removable: true },
        { title: 'France', value: 'fr', removable: true },
        { title: 'Japan', value: 'jp', removable: true },
        { title: 'Australia', value: 'au', removable: true },
        { title: 'India', value: 'in', removable: true },
        { title: 'Brazil', value: 'br', removable: true },
        { title: 'South Africa', value: 'za', removable: true },
        { title: 'Russia', value: 'ru', removable: true },
        { title: 'China', value: 'cn', removable: true },
        { title: 'Italy', value: 'it', removable: true },
        { title: 'Spain', value: 'es', removable: true },
        { title: 'Netherlands', value: 'nl', removable: true },
        { title: 'Sweden', value: 'se', removable: true },
        { title: 'Norway', value: 'no', removable: true },
        { title: 'Finland', value: 'fi', removable: true },
        { title: 'Denmark', value: 'dk', removable: true },
        { title: 'Poland', value: 'pl', removable: true }
      ],
      selectedItems: [],
      label: true,
      optionalText: undefined,
      mandatory: undefined,
      placeholder: true,
      helperMessage: undefined,
      errorMessages: undefined,
      disabled: undefined,
      width: true,
      removable: undefined
    };
  },
  methods: {
    handleAddItem(item) {
      this.items.push(item);
    },
    handleRemoveItem(itemId) {
      const index = this.items.findIndex((i) => i.value === itemId);
      if (index !== -1) {
        this.items.splice(index, 1);
      }
    }
  }
};
</script>
